import { Option } from '@/atoms/select'
import { BaseButton } from '@/components/button/BaseButton'
import { BaseInput } from '@/components/input/BaseInput'
import { CheckBox } from '@/components/input/CheckBox'
import { BaseSelect } from '@/components/select/BaseSelect'
import { css, Theme } from '@emotion/react'
import { ChangeEventHandler } from 'react'
import { CsvMenu } from '@/features/CsvMenu'
import { tableName } from '@/types/tableName'
import { HelpIcon } from '@/components/icon/HelpIcon'

const searchButtonStyle = css`
  width: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const iconStyle = css`
  width: 16px;
  height: 16px;
  fill: currentColor;
  flex-shrink: 0;
`

const searchInputStyle = css`
  width: 306px;
  height: 38px;
`

const contaier = css`
  display: flex;
  justify-content: space-between;
`
const searchConstainer = css`
  display: flex;
  column-gap: 10px;
`
const errorStyle = (t: Theme) => css`
  color: ${t.c.bc.error};
  font-size: 1.4rem;
  margin: auto;
`
const csvMenuContainer = css`
  margin-left: auto;
`

type Props = {
  helpText?: string
  keyword?: string
  onChange?:
    | ChangeEventHandler<HTMLInputElement | HTMLSelectElement>
    | undefined
  onClick?: () => void
  errorMessage?: string
  csvMenuVisible?: boolean
  csvDataType?: tableName | null
  isNeedObsoleteVisible?: boolean
  isNeedObsoleteChecked?: boolean
}

export const SearchForm = ({
  helpText,
  keyword,
  onChange,
  onClick,
  errorMessage = '',
  csvMenuVisible = false,
  csvDataType = null,
  isNeedObsoleteVisible = false,
  isNeedObsoleteChecked = false,
}: Props) => {
  return (
    <>
      <div css={contaier}>
        <div css={searchConstainer}>
          {helpText && <HelpIcon text={helpText} size="medium" />}
          <BaseInput
            name={'keyword'}
            value={keyword}
            onChange={onChange}
            addStyle={searchInputStyle}
          />
          <BaseButton
            color="outline"
            size="fixed38"
            addStyle={searchButtonStyle}
            onClick={onClick}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              css={iconStyle}
            >
              <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
            </svg>
            検索
          </BaseButton>
          {isNeedObsoleteVisible && (
            <CheckBox
              name={'isNeedObsolete'}
              onChange={onChange}
              label={'廃止済みを含む'}
              isChecked={isNeedObsoleteChecked}
            />
          )}
          {errorMessage && <div css={errorStyle}>{errorMessage}</div>}
        </div>
        {csvMenuVisible && csvDataType && (
          <CsvMenu tableName={csvDataType} css={csvMenuContainer} />
        )}
      </div>
    </>
  )
}
